"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumeroPvs = void 0;
var bson_1 = require("bson");
var NumeroPvs = /** @class */ (function () {
    function NumeroPvs(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.qtdPv, qtdPv = _c === void 0 ? 6 : _c;
        this._id = _id;
        this.qtdPv = qtdPv;
    }
    return NumeroPvs;
}());
exports.NumeroPvs = NumeroPvs;
//# sourceMappingURL=NumeroPvs.js.map